
  
<script setup lang="ts">
import { ref } from "vue";
import * as LottiePlayerModule from "@lottiefiles/lottie-player";
import { info } from "@/lib/init";
import { onMounted, defineProps, withDefaults } from "vue";

interface Props {
    type?: boolean;
    autoplay?: boolean;
    controls?: boolean;
    loop?: boolean;
    mode?: string;
    patern?: string;
}

const {
    type,
    autoplay,
    controls,
    loop,
    mode,
    patern
} = withDefaults(defineProps<Props>(), {
    type: false,
    autoplay: true,
    controls: false,
    loop: true,
    mode: "normal",
    patern: ""
});

const fileSrc = info().url?.base.absolute + "/images/" + patern;
const style = { width: "100%" };

const lottiePlayerRef = ref<LottiePlayerModule.LottiePlayer>();

onMounted(() => {
    const lottiePlayer = new LottiePlayerModule.LottiePlayer();
    lottiePlayerRef.value = lottiePlayer;
    // lottiePlayer.setSpeed(2);
    // lottiePlayer.play();
});
</script>
  
<style scoped lang="scss"></style>
<template>
    <div class="lottie">
        <lottie-player ref="lottiePlayer" :type="type" :autoplay="autoplay" :controls="controls" :loop="loop" :mode="mode"
            :src="fileSrc" :style="style"></lottie-player>
    </div>
</template>